module.exports = __webpack_public_path__ + "media/images/icon__nativeAppShare@2x-ee7b352affc16f98d80c5b71f6646066.png";